import { Box, FormControlLabel, FormGroup, FormLabel, MenuItem, Modal, Radio, RadioGroup, Select, SelectChangeEvent, TextField } from '@mui/material'
import React, { FormEvent } from 'react'
import { CrossIcon } from '../../utils/functions/Icons'
import styles from "../../assets/styles/profile.module.css";
import { handleKeyPress } from '../../utils/functions/common';
import { DatePicker } from '@mui/x-date-pickers';
import moment, { Moment } from 'moment';
import BtnLoader from '../common/BtnLoader';

interface propTypes {
    openAddModal: boolean,
    closeAddModal: () => void,
    handleSubmit: (e: FormEvent<HTMLFormElement>) => void,
    btnLoading: boolean,
    title?: string;
    stateData: StateType[],
    cityData: CityType[],
    formStates: PreEmploymentFormTypes;
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    handleDateChange: (date: Date, name: string) => void;
    handleSelectChange: (e: SelectChangeEvent<string>) => void;
}
const AddEmployModal: React.FC<propTypes> = ({ openAddModal, closeAddModal, handleSubmit, stateData, cityData, btnLoading, title, formStates, handleInputChange, handleDateChange, handleSelectChange }) => {
    return (
        <Modal
            open={openAddModal}
            onClose={closeAddModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={{ width: 800 }} className={`ModalBoxStyle`}>
                <div className="modalHeader">
                    <h3> {title ? title : 'Are you sure, you want to cancel this appointment'} </h3>
                    <CrossIcon onClick={closeAddModal} />
                </div>
                <div className='ModalContentSection'>
                    <form noValidate={false} onSubmit={handleSubmit}>
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 lg:gap-4">
                            <FormGroup className="customFormGroup">
                                <FormLabel className="customFormLabel">Name <span className='errorMsg'>*</span></FormLabel>
                                <TextField
                                    type='text'
                                    className={`custumTextField profileInput`}
                                    name="name"
                                    required
                                    value={formStates.name ?? ''}
                                    onChange={handleInputChange}
                                    onKeyPress={(event) => {
                                        if (!/[a-zA-Z\s]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                            </FormGroup>
                            <FormGroup className="customFormGroup">
                                <FormLabel className="customFormLabel">Email Address <span className='errorMsg'>*</span></FormLabel>
                                <TextField
                                    type='email'
                                    className={`custumTextField profileInput`}
                                    name="email"
                                    required
                                    value={formStates.email ?? ''}
                                    onChange={handleInputChange}
                                />
                            </FormGroup>
                            <FormGroup className="customFormGroup">
                                <FormLabel className="customFormLabel">Mobile <span className='errorMsg'>*</span></FormLabel>
                                <TextField
                                    type='text'
                                    className={`custumTextField profileInput`}
                                    name="phone"
                                    required
                                    value={formStates.phone ?? ''}
                                    onChange={handleInputChange}
                                    inputProps={{
                                        inputMode: 'numeric',
                                        maxLength: 10,
                                    }}
                                    onKeyPress={handleKeyPress}
                                />
                            </FormGroup>
                            <FormGroup className="customFormGroup">
                                <FormLabel className="customFormLabel">Date of Birth <span className='errorMsg'>*</span></FormLabel>
                                <DatePicker
                                    className="custumTextField profileInput"
                                    value={formStates.dateOfBirth ? moment(formStates.dateOfBirth, 'YYYY-MM-DD') : null}
                                    maxDate={moment(new Date(), 'YYYY-MM-DD')}
                                    format="YYYY-MM-DD"
                                    onChange={(date) => handleDateChange(moment(date)?.toDate(), 'dateOfBirth')}
                                    slotProps={{
                                        textField: {
                                            required: true,
                                        }
                                    }}
                                />
                            </FormGroup>
                            <FormGroup className="customFormGroup">
                                <FormLabel className="customFormLabel">Age</FormLabel>
                                <TextField
                                    type='text'
                                    className={`custumTextField profileInput`}
                                    name="age"
                                    disabled
                                    value={formStates.age ?? ''}
                                    onChange={handleInputChange}
                                />
                            </FormGroup>
                            <FormGroup className="customFormGroup">
                                <FormLabel className="customFormLabel">Gender </FormLabel>
                                <Select
                                    className={`custumTextField profileInput`}
                                    value={formStates.gender}
                                    name='gender'
                                    onChange={handleSelectChange}
                                >
                                    <MenuItem value="male">Male</MenuItem>
                                    <MenuItem value="female">Female</MenuItem>
                                    <MenuItem value="others">Others</MenuItem>
                                </Select>
                            </FormGroup>
                            <FormGroup className="customFormGroup">
                                <FormLabel className="customFormLabel">Pin Code <span className='errorMsg'>*</span></FormLabel>
                                <TextField
                                    type='text'
                                    className={`custumTextField profileInput`}
                                    name="zipCode"
                                    required
                                    value={formStates.zipCode ?? ''}
                                    onChange={handleInputChange}
                                    inputProps={{
                                        inputMode: 'numeric',
                                        maxLength: 6,
                                    }}
                                    onKeyPress={handleKeyPress}
                                />
                            </FormGroup>
                            <FormGroup className="customFormGroup">
                                <FormLabel className="customFormLabel">State <span className='errorMsg'>*</span></FormLabel>
                                <Select
                                    className={`custumTextField profileInput`}
                                    placeholder="Select state"
                                    value={formStates?.state}
                                    name='state'
                                    onChange={handleSelectChange}
                                    required
                                >
                                    {
                                        stateData?.length > 0 && stateData?.map((item, index) => {
                                            return (
                                                <MenuItem key={index} value={item?.id}>{item?.state}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormGroup>
                            <FormGroup className="customFormGroup">
                                <FormLabel className="customFormLabel">City <span className='errorMsg'>*</span></FormLabel>
                                <Select
                                    className={`custumTextField profileInput`}
                                    placeholder="Select city"
                                    value={formStates?.city}
                                    defaultValue={formStates?.city || ''}
                                    name='city'
                                    required
                                    disabled={formStates?.state !== "" ? false : true}
                                    onChange={handleSelectChange}
                                >
                                    {
                                        cityData?.length > 0 && cityData?.map((item, index) => {
                                            return (
                                                <MenuItem key={index} value={item?.id}>{item?.city}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormGroup>
                            <FormGroup className="customFormGroup">
                                <FormLabel className="customFormLabel">Health checkup date <span className='errorMsg'>*</span></FormLabel>
                                <DatePicker
                                    className="custumTextField profileInput"
                                    value={formStates.health_check_up_date ? moment(formStates.health_check_up_date, 'YYYY-MM-DD') : null}
                                    minDate={moment(new Date(), 'YYYY-MM-DD')}
                                    format="YYYY-MM-DD"
                                    onChange={(date) => handleDateChange(moment(date)?.toDate(), 'health_check_up_date')}
                                    slotProps={{
                                        textField: {
                                            required: true,
                                        }
                                    }}
                                />
                            </FormGroup>
                            <FormGroup className="customFormGroup lg:col-span-2">
                                <FormLabel className="customFormLabel">Type <span className='errorMsg'>*</span></FormLabel>
                                <RadioGroup
                                    row
                                    className='gap-6'
                                    name={'type'}
                                    value={formStates?.type}
                                    onChange={handleInputChange}
                                >
                                    <FormControlLabel
                                        value="anual"
                                        control={<Radio className='customRadio' required />}
                                        label="Annual Check-up"
                                    />
                                    <FormControlLabel
                                        value="pre-enroll"
                                        control={<Radio className='customRadio' required />}
                                        label="Pre-Employment"
                                    />
                                </RadioGroup>
                            </FormGroup>
                        </div>
                        <button className='fillButton mt-8' disabled={btnLoading}> {btnLoading && <BtnLoader />} Add employee +</button>
                    </form>
                </div>
            </Box>
        </Modal>
    )
}

export default AddEmployModal